const HAT_HANDLE = "snapback-hat";
let hatVariantId = null, hatVariantPrice = 0;

// Fetch current cart
async function getCart() {
  const res = await fetch("/cart.js");
  return await res.json();
}

// Add hat to cart
async function addHatToCart(variantId) {
  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });
  // console.log(res);
  // const data = await res.json();
  console.log("Free hat added to cart.");
  // return data;
}

// Remove hat from cart
async function removeHatFromCart(hatLineItemKey) {
  const res = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: hatLineItemKey, quantity: 0 })
  });
  const data = await res.json();
  console.log("Free hat removed from cart.");
  localStorage.removeItem("shopify_discount_code");
  return data;
}

// Get hat variant ID
async function fetchHatVariant() {
  const res = await fetch(`/products/${HAT_HANDLE}.js`);
  const data = await res.json();
  if (data.variants.length) {
    hatVariantId = data.variants[0].id;
  }
}

// Main promo check
window.checkPromoGift = async function () {
  const cart = await getCart();
  const discountCode = localStorage.getItem("shopify_discount_code") || "";

  const subtotal = cart.items.reduce((sum, item) => {
    return item.discounted_price < item.original_price
      ? sum
      : sum + item.original_price * item.quantity;
  }, 0);

  let hatLineItemKey = null;
  const hasHat = cart.items.some(item => {
    if (item.handle === HAT_HANDLE) {
      hatLineItemKey = item.key;
      hatVariantPrice = item.line_price;
      return true;
    }
    return false;
  });

  // 🔒 Check if discount code exists AND subtotal is high enough
  const isEligible = discountCode.toUpperCase() == "TSTN2025" && subtotal >= 39900;

  if (isEligible && !hasHat && hatVariantId) {
    await addHatToCart(hatVariantId);
  } else if ((!isEligible || subtotal < (39900 + hatVariantPrice)) && hasHat && hatLineItemKey) {
    await removeHatFromCart(hatLineItemKey);
  }
};

const input = document.getElementById("discount-code");
const button = document.getElementById("apply-discount");
const clearIcon = document.getElementById("clear-discount");

function updateClearIcon() {
  clearIcon.style.display = input.value.trim() ? "inline" : "none";
}
button.addEventListener("click", async () => {
  const code = input.value.trim();
  console.log("Applying discount code:", code);
  if (code) {
    localStorage.setItem("shopify_discount_code", code);
    updateClearIcon();
    await window.CartActive.updateContent()
    document.querySelector(".btn-checkout").setAttribute("href", "/checkout?discount=" + code);
  }
});

clearIcon.addEventListener("click", async () => {
  await window.CartActive.updateContent()
  localStorage.removeItem("shopify_discount_code");
  input.value = "";
  updateClearIcon();
  document.querySelector(".btn-checkout").setAttribute("href", "/checkout");
});

input.addEventListener("input", updateClearIcon);
(async () => {
  const savedCode = localStorage.getItem("shopify_discount_code");
  console.log("Saved discount code:", savedCode);
  if (savedCode) {
    await window.CartActive.updateContent();
    input.value = savedCode;
    updateClearIcon();
    document.querySelector(".btn-checkout").setAttribute("href", "/checkout?discount=" + savedCode);
  }
})();
fetchHatVariant();
window.checkPromoGift();
